var React = require('react');

function Fax (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.86,1.14V.29H2.28v.85a.14.14,0,0,0,.14.14.15.15,0,0,0,.15-.14v-1A.15.15,0,0,0,2.42,0H.71A.14.14,0,0,0,.57.14v1a.14.14,0,0,0,.14.14.15.15,0,0,0,.15-.14Z","key":0}),React.createElement("path",{"d":"M.71,2.28H.43a.15.15,0,0,1-.15-.14V1.43a.15.15,0,0,1,.15-.15H2.71a.15.15,0,0,1,.14.15v.71a.14.14,0,0,1-.14.14H2.42a.15.15,0,0,0-.14.15.15.15,0,0,0,.14.14h.29a.44.44,0,0,0,.43-.43V1.43A.43.43,0,0,0,2.71,1H.43A.43.43,0,0,0,0,1.43v.71a.43.43,0,0,0,.43.43H.71a.15.15,0,1,0,0-.29Z","key":1}),React.createElement("path",{"d":"M2.57,1.85a.15.15,0,0,0-.15-.14H.71a.14.14,0,0,0-.14.14V3a.14.14,0,0,0,.14.14H2.42A.15.15,0,0,0,2.57,3V1.85Z","key":2})]);
}

Fax.defaultProps = {"viewBox":"0 0 3.14 3.14","fillRule":"evenodd"};

module.exports = Fax;

Fax.default = Fax;
